import { Link } from 'react-router-dom';
import { useStateQuery } from '../api/state';
import { FloorCard } from '../components/FloorCard';
import { GroupRow } from '../components/GroupRow';
import type { FloorName, GroupName } from '../domain';
import { deriveActivity } from '../domain/wpm-status';

const FLOORS: readonly FloorName[] = ['ground', 'middle', 'top'];
const GROUPS: readonly GroupName[] = ['ground', 'middle_sun', 'middle_shade', 'top_sun', 'top_shade'];

function Skeletons() {
  return (
    <>
      {[0, 1, 2].map((i) => (
        <div key={i} className="card">
          <div className="skeleton" style={{ height: 60 }} />
        </div>
      ))}
    </>
  );
}

export function HomePage() {
  const { data, isLoading, isError, error } = useStateQuery();

  return (
    <>
      <h2>Floors</h2>
      {isLoading && <Skeletons />}
      {isError && <div className="banner danger" role="alert">Failed to load: {(error as Error).message}</div>}
      {data && FLOORS.map((floor) => (
        <FloorCard key={floor} floor={floor} state={data.floors[floor]} />
      ))}

      <h2>Actuator groups</h2>
      <div className="card">
        {data && GROUPS.map((group) => <GroupRow key={group} group={group} state={data.groups[group]} />)}
        {isLoading && <div className="skeleton" style={{ height: 120 }} />}
      </div>

      <h2>Heat pump</h2>
      <Link to="/heat-pump" className="card" style={{ display: 'block', color: 'inherit' }}>
        {data ? (
          <>
            <div className="group-row"><span>Link health</span><span className={`tag ${data.heat_pump.link_health === 'alive' ? 'open' : 'closed'}`}>{data.heat_pump.link_health}</span></div>
            <div className="group-row"><span>Status</span><span><span className="tag">{data.heat_pump.operating_mode}{data.heat_pump.summer_mode ? ' · summer' : ''}</span><span className={`tag ${deriveActivity(data.heat_pump).tone}`} style={{ marginLeft: 'var(--sp-2)' }}>{deriveActivity(data.heat_pump).label}</span>{deriveActivity(data.heat_pump).pumping && <span className="tag heat" style={{ marginLeft: 'var(--sp-2)' }}>pumping</span>}</span></div>
            <div className="group-row"><span>Outside</span><span className="tabular">{data.heat_pump.outside_temp_c.toFixed(1)} °C</span></div>
            <div className="group-row"><span>Flow temp</span><span className="tabular">{data.heat_pump.current_flow_temp_c.toFixed(1)} °C</span></div>
            {data.heat_pump.dewpoint_alarm && <div className="group-row"><span style={{ color: 'var(--warning)' }}>Dew-point alarm</span></div>}
          </>
        ) : <div className="skeleton" style={{ height: 120 }} />}
      </Link>

      <p style={{ marginTop: 'var(--sp-3)' }}>
        <Link to="/trends">Trends (daily temperature &amp; usage rollups) →</Link>
      </p>
    </>
  );
}
